<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_bi8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="!parentData.isDetail" @click="funcAdd">
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="name"
          title="分组名称"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="分组名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="createdByName"
          title="创建人"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="创建人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="420"
          field="gmtCreated"
          title="创建时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="!parentData.isDetail"
        title="操作"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="1000"
      height="600"
      resize
    >
      <!-- modelAddFlag 解决宽度异常问题 -->
      <compAdd
        v-if="modelAddFlag"
        :restaurants="restaurants"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="1000"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        :restaurants="restaurants"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/vehicleTeamAdd.vue";
import compEdit from "./components/vehicleTeamEdit.vue";
import {
  driverListForShipTeam,
  getVehicleTeamList,
  delVehicleTeam
} from "@/api/shipment";
export default {
  name: "VehicleTeamList",
  components: {
    compAdd,
    compEdit
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicleTeam/exportVehicleTeam", //导出接口
        name: "承运分组"
      },
      restaurants: [], // 实际承运人列表
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        userCode: "",
        name: "",
        createdByName: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    let branchCodeExt = this.$route.query.branchCode || "";
    //查询独立实际承运人+车队，不包含车队的实际承运人
    driverListForShipTeam({
      pageSize: 100000,
      driverType: 3,
      authStatus: 3,
      isFreeze: 0,
      branchCodeExt
    }).then(response => {
      this.restaurants = response.data.records;
    });
    // this.findList();
  },
  methods: {
    // 获取/查询 列表
    findList() {
      this.loading = true;
      this.listQuery.userCode = this.$route.query.partyCode
        ? this.$route.query.partyCode
        : "";
      return new Promise(resolve => {
        getVehicleTeamList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 排序
    sortList({ column, property, order }) {
      var str = property === "createdByName" ? "createdBy" : property;
      if (order) {
        this.listQuery.sortField = str;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 新增
    funcAdd() {
      this.modelAddFlag = true;
    },
    // 编辑
    funcEdit(row) {
      this.modelEditFlag = true;
      this.$refs.editRef.getInfo(row.name, row.code);
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delVehicleTeam({ teamCodes: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
      }
    }
  }
};
</script>
